// Общие части целей: полоска прогресса (используется и на «Сегодня»).

import { Badge } from '@/components/ui'
import { formatNumber } from '@/lib/format'

import type { Goal } from './api'
import { goalDeadline, goalNumbers, goalVerdict } from './logic'

export function GoalBar({ goal }: { goal: Goal }) {
  const percent = goal.progress.percent
  const verdict = goalVerdict(goal)
  const deadline = goalDeadline(goal)
  return (
    <div className="min-w-0">
      <div className="flex items-center gap-2">
        <span className="min-w-0 flex-1 truncate text-sm font-medium text-fg">{goal.title}</span>
        {verdict ? <Badge tone={verdict.tone}>{verdict.text}</Badge> : null}
      </div>
      <div
        role="progressbar"
        aria-label={goal.title}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={percent ?? 0}
        className="mt-1.5 h-2 overflow-hidden rounded-full bg-surface-2"
      >
        <div className="h-full rounded-full bg-accent" style={{ width: `${percent ?? 0}%` }} />
      </div>
      <div className="mt-1 flex flex-wrap justify-between gap-x-3 text-xs text-muted">
        <span className="tabular-nums">
          {percent === null ? 'Пока нет данных' : `${formatNumber(percent, { digits: 0 })} % · ${goalNumbers(goal)}`}
        </span>
        {deadline ? <span>{deadline}</span> : null}
      </div>
      {goal.progress.forecast ? (
        <p className="mt-0.5 text-xs text-muted">{goal.progress.forecast.message_ru}</p>
      ) : null}
    </div>
  )
}
